<template>
    <v-dialog-old ref="dialog" id="step_two" v-show="visible" @hidden="hide">
        <rightBlock ref="rightBlock" />
        <leftBlock ref="leftBlock" />
        <template v-slot:footer v-if="$can('admin.pricelists.doctu.update')">
            <v-loading-component @click="fireConfirmEvent">
                <template slot-scope="{ loadingClass }">
                    <button :class="[{green: stepThreeAvailable && !btnDisabled}, loadingClass]"
                            v-tooltip="{content: infoTooltip(info.errors_info), template: $errTemplate}"
                            :disabled="btnDisabled">Перейти к матчингу</button>
                </template>
            </v-loading-component>
            <button class="red" @click="cancelParsing">Прервать создание</button>
        </template>
    </v-dialog-old>
</template>

<script>

import LeftBlock from "./LeftBlock"
import RightBlock from "./RightBlock"
import { mapGetters, mapState } from "vuex";

export default {

    components: {
        LeftBlock,
        RightBlock
    },
    data: function () {
        return {
            btnDisabled: false
        };
    },
    methods: {
        infoTooltip(items) {
            let res = ''
            Object.keys(items).forEach((item) => {
                res = res+item+': '+ items[item]+`<br/>`
            })
            if (res !== ''){
                res = "Для продолжения работы исправьте критические ошибки:"+`<br/>` + res;
            }
            return res;
        },
        fireConfirmEvent(btn) {
            if (!this.stepThreeAvailable || this.btnDisabled) {
                return;
            }

            this.btnDisabled = true;
            btn.startLoadingAnimation();

            let requestPromise = this.axios.post('doctu/parseAndMatch/' + this.priceListFileId,
                {'params': this.params});

            requestPromise.then((response) => {
                    this.$emit('nextStep',this.priceListFileId, 'PARSED');
                    this.btnDisabled = false;
                    btn.stopLoadingAnimation();
                },
                () => {
                });
        },
        cancelParsing(comment) {
            this.axios.post('doctu/' + this.priceListFileId + '/parsing_problem', {reason: comment}).then((response) => {
                this.$refs.dialog.hide();
            });
        },
        show(id) {
            this.$store.commit('stepTwo/setPriceListFileId', id)
            return this.$refs.dialog.show().then(() => {
                return this.$refs.leftBlock.refreshLeftTable()
            })
        },
        hide() {
            this.btnDisabled = false;
            this.$parent.$refs.table.update();
        },
    },


    computed: {
        ...mapGetters({
            showRightTable: 'stepTwo/showRightTable',
            stepThreeAvailable: 'stepTwo/stepThreeAvailable',
        }),
        ...mapState({
            info: state => state.stepTwo.info,
            visible: state => state.stepTwo.show,
            params: state => state.stepTwo.params,
            priceListFileId: state => state.stepTwo.priceListFileId,
        }),
    }
    ,
    watch: {}
}
</script>

<style>
#step_two {
    height: 97vh;
    width: 1600px;
}

.fl-r {
    float: right
}
</style>
